export default __webpack_public_path__ + "static/media/24t.2d476891.jpg";